import styled from "styled-components";
import herobg from "../../../assets/images/herobg2.png";

export const MainSection = styled.section`
  background-image: url(${herobg});
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  .imageDivWrapper {
    width: 60%;
    height: 300px;
    display: flex;
    justify-content: center;
    margin-top: 5rem;

    @media (max-width: 990px) {
      display: none;
    }
  }

  .btn-div {
    margin-top: 2rem;

    @media (max-width: 991.98px) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

export const Title = styled.h5`
  /* font-family: "Josefin Sans"; */
  font-style: normal;
  font-size: 67.7007px;
  line-height: 68px;
  color: #ffffff;
  font-weight: 300;
  margin-top: 10rem;
  span {
    color: #ffffff;
    font-weight: 600;
    text-transform: lowercase;
  }

  @media (max-width: 990px) {
    text-align: center;
    font-size: 45px;
  }
`;

export const GetStartBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #032b88;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 21.6642px;
  text-transform: capitalize;
  padding: 0.2em 1.5em;
  /* border-radius: 4px; */
  border: none;
  cursor: pointer;
  margin-top: 2rem;
  color: #ffffff;
  background: linear-gradient(90.41deg, #032b88 0.34%, #032b88 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }
`;

export const ImageContainer = styled.div`
  justify-content: center;
  text-align: end;

  @media (max-width: 991.98px) {
    text-align: center;
    margin-top: 2rem;
  }
`;
